<template>
  <el-dialog
    title="主体合并"
    :visible="visible"
    width="30%"
    @close="handleClose"
  >
    <cus-form
      ref="mergeEntityForm"
      :formDatas="{ labelPositon: 'top' }"
      :formItemDatas="formItemDatas"
      :formModelFn="formModelFn"
      :formRulesFn="formRulesFn"
    ></cus-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="confirmMergeEntity">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cusForm from "@/views/components/cusForm";
export default {
  components: {
    cusForm
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      // 表单
      formItemDatas: [
        {
          label: "请选择要合并到的目标主体",
          type: "select",
          prop: "entity",
          placeholder: "请选择要合并到的目标主体",
          options: [{ id: 1, name: "实例主体1" }]
        }
      ],
      requiredProps: ["entity"]
    };
  },
  computed: {
    formModelFn() {
      let obj = {};
      this.formItemDatas.forEach(item => {
        obj[item.prop] = "";
      });
      return obj;
    },
    formRulesFn() {
      let obj = {};
      let requiredItems = this.formItemDatas.filter(item => {
        return this.requiredProps.some(p => p == item.prop);
      });
      requiredItems.forEach(item => {
        obj[item.prop] = {
          required: true,
          message: item.placeholder,
          trigger: ["change"]
        };
      });
      return obj;
    }
  },
  methods: {
    confirmMergeEntity() {
      this.$refs.mergeEntityForm.$refs.formRef.validate(valid => {
        if (valid) {
          this.$emit(
            "comfirm-merge-entity",
            this.$refs.mergeEntityForm.formModel
          );
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("close-dialog");
      this.$refs.mergeEntityForm.$refs.formRef.resetFields();
    }
  }
};
</script>

<style lang="scss">
</style>